import { PagedResponse } from '@elotech/components';
import { AxiosPromise } from 'axios';
import { Protocolo } from 'common/type';
import { FastField, Field } from 'formik';
import React, { FC } from 'react';

import { ProtocoloSearch, ProtocoloSearchProps } from './ProtocoloSearch';

export type FormikProtocoloSearchProps = Partial<ProtocoloSearchProps> & {
  name: string;
  fast?: boolean;
  onSearch: (search: string) => AxiosPromise<PagedResponse<Protocolo>>;
};

export const FormikProtocoloSearch: FC<FormikProtocoloSearchProps> = ({
  name = 'protocolo',
  onSearch,
  fast = true,
  onSelect,
  ...props
}) => {
  const FormikField = fast ? FastField : Field;

  return (
    <>
      <FormikField
        name={name}
        render={({ field, form }) => (
          <ProtocoloSearch
            {...props}
            {...field}
            onSearch={onSearch}
            onSelect={protocolo => {
              if (onSelect) {
                onSelect(protocolo);
              } else {
                form.setFieldValue(name, protocolo);
                form.setFieldTouched(name, true);
              }
            }}
            error={form.errors[name]}
          />
        )}
      />
    </>
  );
};
